/**
 * Engagement State Machine — Phase 6a.10 per Spec §21.7.4.
 *
 * Pure transition helpers. Callers (auto-draft hook, calculate flow,
 * append-slot action) decide *when* to invoke them; these functions
 * return new `EngagementHistoryEntry` objects without mutating inputs.
 */

import type { EngagementHistoryEntry } from "@/types";

/**
 * Promote an engagement to "calculated" — stamps `calculatedAt`, clears
 * any prior `staleSince`. Used by the Phase 6a.11 calculation flow on
 * successful backend response.
 */
export function transitionToCalculated(
  engagement: EngagementHistoryEntry,
): EngagementHistoryEntry {
  return {
    ...engagement,
    status: "calculated",
    calculatedAt: new Date().toISOString(),
    staleSince: undefined,
    isStale: false,
    updatedAt: new Date().toISOString(),
  };
}

/**
 * Mark a calculated engagement as stale (Six Golden Rule 5 — any field
 * change in a calculated engagement immediately invalidates the cached
 * results). No-op for draft/stale engagements.
 */
export function transitionToStale(
  engagement: EngagementHistoryEntry,
): EngagementHistoryEntry {
  if (engagement.status !== "calculated") return engagement;
  const now = new Date().toISOString();
  return {
    ...engagement,
    status: "stale",
    staleSince: now,
    isStale: true,
    updatedAt: now,
  };
}
